import type { ArticleMeta } from '@/components/ArticleLayout.tsx';
import { ArticleLayout, PullQuote } from '@/components/ArticleLayout.tsx';

const META: ArticleMeta = {
  source: 'GlobeNewswire',
  date: 'November 18, 2025',
  title: 'Lux Financial to Offset $2B in Tax Equity Investments',
  lead: 'Lux Financial plans to offset nearly $2 billion in tax equity through energy investments, partnering with CPA and wealth management firms to provide transparent, technology-driven investment tools.',
  image: 'images/article-2b-offset-hero.webp',
  imageAlt:
    'Business professional reviewing tax equity investment plans on a laptop',
  imageWidth: 960,
  imageHeight: 590,
  sourceUrl:
    'https://www.globenewswire.com/news-release/2025/11/18/3190549/0/en/Lux-Financial-to-Offset-2B-in-Tax-Equity-Investments.html',
  disclaimer:
    'This article originally appeared via GlobeNewswire. It is reproduced here for informational purposes only and does not constitute financial, investment, or legal advice.',
};

export function Article2BOffset() {
  return (
    <ArticleLayout meta={META}>
      <p>
        Lux Financial plans to offset nearly $2 billion in tax equity through
        energy investments. The company partners with CPA and wealth management
        firms to provide transparent, technology-driven investment tools for
        clients seeking to reduce their tax liabilities.
      </p>
      <p>
        LEHI, Utah, Nov. 18, 2025 (GLOBE NEWSWIRE) — Lux Financial announced
        plans to offset approximately $2 billion in tax equity investments for
        its partners over the next few years, signaling its growing presence in
        the renewable energy tax credit market. The firm partners with certified
        public accountants and wealth managers to help individuals and
        businesses participate in energy-based investment programs that lower
        tax exposure while promoting energy growth.
      </p>
      <p>
        The market for transferable tax credits has grown sharply, with
        projections estimating total monetization between $55 billion and $60
        billion in 2025. Lux Financial is positioning itself to capture a
        significant share by offering energy-driven tax solutions tailored for
        private clients and institutions.
      </p>

      <PullQuote attribution="Shawn Smart, CEO of Lux Financial">
        &ldquo;We saw a real gap for investors looking to participate in tax
        equity opportunities that actually make sense. The response was
        incredible — it became clear this was something clients were waiting
        for. We&rsquo;re aiming to help our partners offset nearly $2 billion in
        tax equity in the coming years.&rdquo;
      </PullQuote>

      <p>
        Lux Financial distinguishes itself from other energy and tax equity
        providers such as Sunrun, SunPower, and Monarch Private Capital through
        its proprietary technology platform. Investors and advisors receive
        real-time access to performance data, offering a degree of transparency
        uncommon in traditional tax equity investments. The system allows users
        to track the progress and returns of energy projects, particularly in
        the rapidly expanding energy storage sector, which accounted for roughly
        26 percent of tax credits sold during the first half of 2025.
      </p>
      <p>
        The company&rsquo;s model prioritizes collaboration with financial
        professionals. Lux Financial offers tax strategy support to CPA and
        advisory partners at no extra cost, helping them match energy-based
        products with each client&rsquo;s tax profile. This structure benefits
        both sides of the partnership by improving decision-making and
        strengthening client relationships.
      </p>

      <PullQuote attribution="Shawn Smart, CEO of Lux Financial">
        &ldquo;Our philosophy is simple: if it&rsquo;s not good for one,
        it&rsquo;s not good for all. We&rsquo;ve built a culture around
        collaboration and shared success, helping investors and their advisors
        win together.&rdquo;
      </PullQuote>

      <p>
        Lux Financial reports steady year-over-year growth as more clients seek
        practical methods to manage tax obligations through verified energy
        assets.
      </p>

      <h2>About Lux Financial</h2>
      <p>
        Lux Financial provides energy investment products that help clients
        reduce tax liabilities through verified energy projects. The company
        operates exclusively through CPA and wealth management partnerships,
        offering advanced investment monitoring tools and advisor support.
      </p>
    </ArticleLayout>
  );
}
